<template>
  <tr :class="{'disabled': taskType.validUntil}"
      @dblclick="$router.push( {name: 'taskTypeEdit', params: {id: taskType.id}})"
  >
    <td class="asd-btn-group">
      <button v-if="taskType.validUntil === null"
              v-help.mouse="'Editovat typ úkolu'"
              class="asd-btn-edit"
              @click="$router.push( {name: 'taskTypeEdit', params: {id: taskType.id}})"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>
    </td>
    <td>
      <span v-if="taskType">
        {{ taskType.name }}
      </span>
    </td>
    <td>
      {{ taskType.validUntil | formatTimestamp }}
    </td>
    <td class="properties-names">
      <span v-for="pt in propertyTypes" :key="pt.id"
            v-help.mouse="pt.activeUntil !== null ? 'Tato vlastnost je deaktivována. Reaktivovat ji můžete v editaci vlastností.|Pokud jí jíž v tomto typu projektu nechcete musíte jí ručně odstranit.' : false"
            :class="{'disabled': pt.activeUntil !== null}"
      >
        {{ pt.name }},
      </span>
    </td>
  </tr>
</template>

<script>
import TaskTypeDataMixin from 'CORE/mixins/task-type-data'
import _ from 'lodash'
import { czSorter } from 'CORE/utils/sorters'

export default {
    name: 'ProjectRow',
    mixins: [
        TaskTypeDataMixin,
    ],
    props: {
        taskTypeId: {
            type: String,
            required: true,
        },
    },
    computed: {
        propertyTypes() {
            let pt = _.get(this.taskType, 'propertyType', [])
            pt = _.sortWith(pt, (a, b) => czSorter('asc')(...[a, b].map(c => _.get(c, 'name'))))
            return pt
        },
    },
}
</script>
